module.exports = __webpack_public_path__ + "static/media/Project.1c84913d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/Project.scss
// module id = 254
// module chunks = 0